import {Link} from "react-router-dom";
import {EmptyProductCardComponent, ProductCardComponent, ProductExternalCardComponent} from "./products.component";

export const ProductsSectionComponent = ({title, label, products , slug}) => {
    return(
        <div className={"mx-auto w-full md:w-11/12 lg:w-full "} style={{maxWidth:"1500px"}}>
            <div className={"w-full "}>
                <div>
                    <div>
                        <div className={"border-t border-gray-200 py-6"}>

                        </div>
                    </div>
                </div>
                <div className={"w-full flex "}>
                    <div className={"w-full md:w-6/12 pb-12 md:pb-14 mx-auto"}>
                        <div className={"text-center block lg:flex items-center"}>
                            <div className={"lg:border-r ms-auto lg:pe-6 border-gray-700"}>
                                <h1 className={"text-main line-clamp-2 text-2xl lg:text-3xl font-semibold "}>
                                    {title}</h1>
                            </div>
                            <div className={"me-auto md:ms-0 lg:ps-6 ms-auto lg:me-auto"}>
                                <h4 className={"text-red-600 font-semibold text-md"}>{label}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"w-full"}>
                    <div className={"w-full max:w-11/12 mx-auto"}>
                        {products?.length === 0 ? (
                            <div className={""}>
                                <ul className={"w-full sm:w-11/12 mx-auto lg:w-full xl:w-11/12 md:w-11/12 flex flex-wrap "}>
                                    <li key={0} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={1} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={2} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={3} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        ) : (
                            <ul className={"w-full sm:w-11/12 mx-auto lg:w-full xl:w-11/12 md:w-11/12 flex flex-wrap "}>
                                {products.map((item, index) => {
                                    return(
                                        <li key={index} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                            <div className={""}>
                                                <ProductCardComponent index={index} name={item?.name} category={item?.category?.name} slug={item?.slug} model={item?.model?.name} type={item?.type} brochure={item?.brochure} image={item?.main_image}  />
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
            <div className={"pb-5"}>
                <div className={"py-6 text-center items-center"}>
                    <Link to={`/catalog?${slug}`}>
                        <button className={"btn-main text-sm py-3 px-6 rounded-lg"}>
                            Lihat Lebih Banyak
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export const ProductsExternalSectionComponent = ({title, label, products , slug}) => {
    return(
        <div className={"mx-auto w-full md:w-11/12 lg:w-full "} style={{maxWidth:"1500px"}}>
            <div className={"w-full "}>
                <div>
                    <div>
                        <div className={"border-t border-gray-200 py-6"}>

                        </div>
                    </div>
                </div>
                <div className={"w-full flex "}>
                    <div className={"w-full md:w-6/12 pb-12 md:pb-14 mx-auto"}>
                        <div className={"text-center block lg:flex items-center"}>
                            <div className={"lg:border-r ms-auto lg:pe-6 border-gray-700"}>
                                <h1 className={"text-main line-clamp-2 text-2xl lg:text-3xl font-semibold "}>
                                    {title}</h1>
                            </div>
                            <div className={"me-auto md:ms-0 lg:ps-6 ms-auto lg:me-auto"}>
                                <h4 className={"text-red-600 font-semibold text-md"}>{label}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"w-full"}>
                    <div className={"w-full max:w-11/12 mx-auto"}>
                        {products?.length === 0 ? (
                            <div className={""}>
                                <ul className={"w-full sm:w-11/12 mx-auto lg:w-full xl:w-11/12 md:w-11/12 flex flex-wrap "}>
                                    <li key={0} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={1} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={2} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                    <li key={3} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                        <div className={""}>
                                            <EmptyProductCardComponent index={0} />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        ) : (
                            <ul className={"w-full sm:w-11/12 mx-auto lg:w-full xl:w-11/12 md:w-11/12 flex flex-wrap "}>
                                {products.map((item, index) => {
                                    return(
                                        <li key={index} className={"w-6/12 md:w-6/12  lg:mx-0 lg:w-3/12"}>
                                            <div className={""}>
                                                <ProductExternalCardComponent index={index} name={item?.name} category={item?.category?.name} slug={item?.slug} model={item?.model?.name} type={item?.type} brochure={item?.brochure} image={item?.main_image}  />
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
            <div className={"pb-5"}>
                <div className={"py-6 text-center items-center"}>
                    <Link to={`https://checkweigher.co.id/catalog`}>
                        <button className={"btn-main text-sm py-3 px-6 rounded-lg"}>
                            Lihat Lebih Banyak
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
}
